import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceDetailsComponent } from './service-details.component';
import { FormsModule } from '@angular/forms';
import { CoreModule, FormControlModule } from '@linkdev/shared-library';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'ngx-swiper-wrapper';
import {AccordionModule} from 'primeng/accordion';

@NgModule({
  declarations: [ServiceDetailsComponent],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    FormControlModule,
    RouterModule,
    SwiperModule,
    AccordionModule
  ],
  exports:[ServiceDetailsComponent]
})
export class ServiceDetailsModule { }
